/*
 * This file is part of the nivo project.
 *
 * Copyright 2016-present, Raphaël Benitte.
 *
 * For the full copyright and license information, please view the LICENSE
 * file that was distributed with this source code.
 */
export const DIRECTION_ROW = 'row'
export const DIRECTION_COLUMN = 'column'

export const ANCHOR_TOP = 'top'
export const ANCHOR_TOP_RIGHT = 'top-right'
export const ANCHOR_RIGHT = 'right'
export const ANCHOR_BOTTOM_RIGHT = 'bottom-right'
export const ANCHOR_BOTTOM = 'bottom'
export const ANCHOR_BOTTOM_LEFT = 'bottom-left'
export const ANCHOR_LEFT = 'left'
export const ANCHOR_TOP_LEFT = 'top-left'
export const ANCHOR_CENTER = 'center'

export const DIRECTION_LEFT_TO_RIGHT = 'left-to-right'
export const DIRECTION_RIGHT_TO_LEFT = 'right-to-left'
export const DIRECTION_TOP_TO_BOTTOM = 'top-to-bottom'
export const DIRECTION_BOTTOM_TO_TOP = 'bottom-to-top'
